export enum CONFIGURATION {
  MAX_UPLOAD_SIZE = 'max_upload_size',
  MAX_FILES = 'max_files',
}
